import axios from "axios";
import useSWR from "swr";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: BASE });

const fetcher = (url) => api.get(url).then((r) => r.data);

export function useApi(path, opts = {}) {
  const { data, error, isLoading, mutate } = useSWR(path, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 15000,
    ...opts,
  });
  return { data, error, loading: isLoading, mutate };
}
